import { RESULTS_PER_PAGE } from "../../utils/constants";

export const getCurrentPage = (offset: number, resultsPerPage = RESULTS_PER_PAGE) =>
  offset / resultsPerPage + 1;

export const getOffset = (page: number, resultsPerPage = RESULTS_PER_PAGE) =>
  (page - 1) * resultsPerPage;

export const getTotalPages = (totalResults?: number, resultsPerPage = RESULTS_PER_PAGE) =>
  Math.ceil((totalResults ?? 0) / resultsPerPage);
